import { Autocomplete, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Tooltip } from "@mui/material";
import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { UpdateKafkaOrg } from "../../actions";
import { CancelIcon } from "../../icon";
import { KafkaModel, OrgModel } from "../../models/kafka.model";
import { OrganizationModel } from "../../models/organization.model";
import * as selector from "../../selectors/selectors";
import ButtonComponent from "../shared/button/button.component";
import { buttonLabels } from "../shared/constants";
import { orgSelectedInOtherGroups } from "./kafka.utils";

interface IProps {
    CloseKafkaForm: (confirm: boolean) => void;
    Show: boolean;
    KafkaData: KafkaModel
}

const AddKafkaComponent = (props: IProps) => {
    const dispatch = useDispatch()
    const Organizations: OrganizationModel[] = useSelector(selector.organizations)
    const Kafka: KafkaModel[] = useSelector(selector.kafka)
    const AdminOrganizations = Organizations?.filter(x => x.Name !== "Admin");
    const unmappedOrgs = AdminOrganizations.filter((x) => !orgSelectedInOtherGroups(x, Kafka, props.KafkaData));
    const [IsLoading, SetIsLoading] = useState<boolean>(false);
    const [selectedOrgs, setSelectedOrgs] = useState<OrganizationModel[]>(props.KafkaData ? Organizations.filter(x => props.KafkaData?.Organizations.findIndex(z => z.ID === x.ID) >= 0) : [])
    const [selectAll, setSelectAll] = useState<boolean>(unmappedOrgs.length === selectedOrgs.length);
    const groupId = props.KafkaData?.GroupId ?? Kafka[Kafka?.length - 1]?.GroupId + 1;

    const title = ` ${props.KafkaData?.GroupId === -1 ? "Unassigned" : props.KafkaData?.GroupId === 0 ? "Default Group" : `Group ${groupId}`}`

    const formSubmit = (event: any) => {
        event.preventDefault();
        SetIsLoading(true);
        UpdateKafkaOrg(dispatch, {
            GroupId: groupId,
            Organizations: selectedOrgs.map(x => ({
                ID: x.ID,
                Name: x.Name,
                IsDeleted: x.IsDeleted
            }) as OrgModel)
        } as KafkaModel)
        props.CloseKafkaForm(true)
        SetIsLoading(false);

    }
    return (
        <div>
            <Dialog
                fullWidth
                maxWidth="sm"
                aria-labelledby="responsive-dialog-title"
                open={props.Show}
                BackdropProps={{
                    style: { backgroundColor: "transparent" },
                }}
                className={"dialogue-shadow"}
                disableEscapeKeyDown
            >
                <DialogTitle className="dialog-header p-2">
                    <div className={`h2-regular color-display-title d-flex ml-1`} id="customized-dialog-title">
                        {props.KafkaData ? "Edit Group" : "Add Group Cluster"}
                        <Tooltip title="Close" placement="bottom">
                            <span className="ml-auto mr-1">
                                <CancelIcon className={"c-pointer"} onClick={() => props.CloseKafkaForm(false)} />
                            </span>
                        </Tooltip>
                    </div>
                </DialogTitle>
                <div className={"bb-primary-background-pink-4 mx-2"}></div>
                <DialogContent className={"p-2 o-hidden"}>
                    <form
                        noValidate
                        autoComplete="no"
                    >
                        <Grid container direction="column" className="">
                            <Grid item xs={12}>
                                <TextField
                                    autoFocus
                                    placeholder="Title "
                                    label="Title"
                                    variant="outlined"
                                    size="small"
                                    name="Title"
                                    required
                                    fullWidth
                                    value={title}
                                    onChange={(e) => { }}
                                    disabled
                                />

                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    size="small"
                                    className='mt-1'
                                    classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                    options={unmappedOrgs.length ? [selectAll ? { Name: 'Unselect All', ID: 'unselect-all' } : { Name: 'Select All', ID: 'select-all' }, ...unmappedOrgs] : []}
                                    getOptionLabel={(option) => option?.Name}
                                    onChange={(event: any, value: any | null) => {
                                        const lastSelection = value.pop();
                                        if (lastSelection?.ID === 'select-all') {
                                            setSelectedOrgs(unmappedOrgs)
                                            setSelectAll(true)
                                        }
                                        else if (lastSelection?.ID === 'unselect-all') {
                                            setSelectedOrgs([])
                                            setSelectAll(false)
                                        }
                                        else {
                                            setSelectedOrgs([...value, lastSelection].filter(x => x))
                                            setSelectAll(false)
                                        }

                                    }}
                                    multiple
                                    value={selectedOrgs}
                                    renderOption={(defaultprops, option: any) => (
                                        <li {...defaultprops} className={" c-pointer h4-regular color-menu-list-font-color p-2 d-flex justify-between w-p-90"}>
                                            {option?.Name}
                                        </li>
                                    )}
                                    renderTags={(value: OrganizationModel[], getTagProps) => (
                                        <div className='h-v-12 o-y-scroll'>
                                            {
                                                value.map((option: OrganizationModel, index: number) => (
                                                    <Chip variant="filled" label={option.Name} {...getTagProps({ index })} />
                                                ))
                                            }
                                        </div>
                                    )}

                                    renderInput={(params) => <TextField {...params} label="Select Organization" name="Select Organization" required variant="outlined" />}
                                />
                            </Grid>

                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions className="p-2">
                    <ButtonComponent OnClick={() => props.CloseKafkaForm(false)} ButtonLabel={buttonLabels.CANCEL} ClassName={" mr-1 ml-auto"} Variant={"secondary-btn-small"} />
                    <ButtonComponent OnClick={formSubmit} Type={"submit"} ButtonLabel={props.KafkaData ? "Save" : "Create"} ClassName={"px-4"} Variant={!selectedOrgs.length && props.KafkaData?.GroupId !== -1 ? "disabled-btn-small" : "primary-btn-small"} Loading={IsLoading} />
                </DialogActions>
            </Dialog>
        </div>
    )
}


export default AddKafkaComponent;
